import { render, staticRenderFns } from "./processDialog.vue?vue&type=template&id=3d90f36b&scoped=true"
import script from "./processDialog.vue?vue&type=script&lang=js"
export * from "./processDialog.vue?vue&type=script&lang=js"
import style0 from "./processDialog.vue?vue&type=style&index=0&id=3d90f36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d90f36b",
  null
  
)

export default component.exports